import React from 'react';
import ContactForm from '../forms/ContactForm'; // Импортируем универсальную форму
import { FileText } from 'lucide-react';

const KtpnContact: React.FC = () => {
  return (
    <section id="contact-form-main" className="py-12 md:py-16 bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column: Text */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Оставьте заявку — мы подготовим коммерческое предложение за 1 день
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Заполните форму, и наш специалист свяжется с вами для уточнения деталей. Мы работаем быстро и ценим ваше время.
            </p>
            <div className="mt-8 bg-green-50 p-4 rounded-lg flex items-center">
              <FileText className="w-6 h-6 mr-3 text-green-600" />
              <p className="font-semibold text-green-800">
                Есть КП от конкурентов? Пришлите — предложим дешевле и быстрее.
              </p>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className="bg-gray-50 p-6 md:p-8 rounded-xl shadow-lg">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default KtpnContact; 